export const FreeDevices = {
  BOTH: 'BOTH',
  TRACKER_ONLY: 'TRACKER_ONLY',
  CAN_ONLY: 'CAN_ONLY'
}

export const ProductGroupCode = {
  CAR: 'szemelyauto',
  TRUCK: 'teherauto',
  MACHINERY: 'munkagep'
}

export const ProductAddonCode = {
  TRACKER: 'tracker',
  CAN_DEVICE: 'can_bus',
  SETUP_FEE: 'setup_fee'
}

export const PackageCodes = {
  BASIC: ['CBA', 'VBA', 'MBA'],
  PLUS: ['CPL', 'VPL', 'MPL'],
  EXTRA: ['CEX', 'VEX', 'MEX']
}
